"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageReducer = void 0;

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _messageActions = require("../actions/messageActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var messageReducer = function messageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var error = '';

  switch (parseInt(action.message, 10)) {
    case _kubraKmap.default.errorCodes.ADDRESS_NOT_FOUND:
      // 1
      error = 'Address was not found';
      break;

    case _kubraKmap.default.errorCodes.ADDRESS_NOT_IN_BOUNDS:
      // 2
      error = 'Address is outside the valid area';
      break;

    case _kubraKmap.default.errorCodes.ADDRESS_SEARCH_FAILED:
      // 3
      error = 'Address search failed';
      break;

    case _kubraKmap.default.errorCodes.OUT_OF_BOUNDS:
      // 4
      error = 'Address is outside the valid area';
      break;

    case _kubraKmap.default.errorCodes.LAT_LNG_NOT_FOUND:
      // 5
      error = 'Could not get Current Location';
      break;

    case NaN:
    default:
      error = action.message;
  }

  switch (action.type) {
    case _messageActions.SHOW_MESSAGE:
      return Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
        errorMessage: {
          message: error,
          fullScreen: action.fullScreen
        }
      }));

    case _messageActions.HIDE_MESSAGE:
      return Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
        errorMessage: undefined
      }));

    default:
      return state;
  }
};

exports.messageReducer = messageReducer;